<template>
  <div>
      <div style="display: flex">
        <v-btn primary dark @click.native="actualizarcliente()">Actualizar</v-btn>
         <v-btn accent dark @click.native="regresar()">Regresar</v-btn>
      </div>

      <GmapMap
        :center="center"
        :zoom="18"
        map-type-id="hybrid"
        style="width: 100%; height: 80vh"
        @click="marcar($event)"

      >
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          :label="cliente.nombre"
          @click="center=m.position"
        />
      </GmapMap>
  </div>
</template>

<script>

export default {
  name: 'ActualizaUbicacionCliente',
  created () {
    this.url = this.$route.params.id
    this.$store.dispatch('getcliente', this.url)
  },
  mounted () {
    setTimeout(() => {
      this.cliente = this.$store.getters.cliente
      if (this.cliente.latitud !== null) {
        this.center = {lat: parseFloat(this.cliente.latitud), lng: parseFloat(this.cliente.longitud)}
        this.markers = [{position: {lat: parseFloat(this.cliente.latitud), lng: parseFloat(this.cliente.longitud)}}]
      } else {
        this.ubicacionactual()
      }
    }, 1000)
  },
  data () {
    return {
      markers: [{position: {lat: 15.590615, lng: -90.102964}}],
      center: {lat: 15.590615, lng: -90.102964},
      latitud: '',
      cliente: {},
      url: ''
    }
  },
  methods: {
    marcar (position) {
      this.$store.dispatch('getcliente', this.url)
      this.center = position.latLng
      this.markers = [{ position: position.latLng }]
      this.latitud = this.center.lng()
    },
    actualizarcliente () {
      this.cliente = this.$store.getters.cliente
      if (typeof (this.center.lat) === 'function') {
        this.cliente.latitud = this.center.lat()
        this.cliente.longitud = this.center.lng()
      } else {
        this.cliente.latitud = this.center.lat
        this.cliente.longitud = this.center.lng
      }
      console.log(this.cliente)
      this.$store.dispatch('editarcliente', this.cliente, true)
    },
    error (dato) {
      console.log(dato)
    },
    success (dato) {
      console.log(dato)
    },
    ubicacionactual () {
      if (navigator.geolocation) {
        var v = this
        navigator.geolocation.getCurrentPosition(
            function (coor) {
              v.center = {lat: coor.coords.latitude, lng: coor.coords.longitude}
              v.markers = [{position: {lat: coor.coords.latitude, lng: coor.coords.longitude}}]
            }
          )
      } else {
        alert('Geolocation is not supported by this browser.')
      }
    },
    regresar () {
      this.$router.push('/clientes')
    }
  }
}
</script>

<style scoped>
  .prueba {
    width: 50%;
    height: 50vh;
    background-color: orange;
  }
</style>



// WEBPACK FOOTER //
// ActualizaUbicacionCliente.vue?192ee3f9